/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Apikey_Nonetocopy3Inputs */

const id_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada kunci API untuk disalin`)
};

const ms_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada kunci API untuk disalin`)
};

const da_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen API nøgle at kopiere`)
};

const de_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein API-Schlüssel zum Kopieren vorhanden`)
};

const en_us2_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key to copy`)
};

const es_es2_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay clave de API para copiar`)
};

const es_mx2_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay API key para copiar`)
};

const fil_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang API key na kopyahin`)
};

const fr_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune clé API à copier`)
};

const it_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna chiave API da copiare`)
};

const hu_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs API kulcs másolni`)
};

const nl_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen API-sleutel om te kopiëren`)
};

const no_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen API-nøkkel å kopiere`)
};

const pl_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak klucza API do skopiowania`)
};

const pt_br2_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key to copy`)
};

const pt_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma chave de API para copiar`)
};

const ro_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicio cheie API de copiat`)
};

const fi_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei API-avainta kopioitavaksi`)
};

const sv_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen API-nyckel att kopiera`)
};

const vi_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có khóa API để sao chép`)
};

const tr_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopyalanacak API anahtarı yok`)
};

const cs_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný API klíč ke kopírování`)
};

const bg_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма API ключ за копиране`)
};

const ru_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет API-ключа для копирования`)
};

const uk_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає API-ключа для копіювання`)
};

const ar_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد مفتاح API للنسخ`)
};

const hi_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉपी करने के लिए कोई API कुंजी नहीं`)
};

const th_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีคีย์ API ให้คัดลอก`)
};

const ja_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーする API キーがありません`)
};

const zh_cn2_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key to copy`)
};

const zh_hant1_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key to copy`)
};

const ko_notifications_apikey_nonetocopy3 = /** @type {(inputs: Notifications_Apikey_Nonetocopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key to copy`)
};

/**
* | output |
* | --- |
* | "No API key to copy" |
*
* @param {Notifications_Apikey_Nonetocopy3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_apikey_nonetocopy3 = /** @type {((inputs?: Notifications_Apikey_Nonetocopy3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Apikey_Nonetocopy3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_apikey_nonetocopy3(inputs)
	if (locale === "ms") return ms_notifications_apikey_nonetocopy3(inputs)
	if (locale === "da") return da_notifications_apikey_nonetocopy3(inputs)
	if (locale === "de") return de_notifications_apikey_nonetocopy3(inputs)
	if (locale === "en-US") return en_us2_notifications_apikey_nonetocopy3(inputs)
	if (locale === "es-ES") return es_es2_notifications_apikey_nonetocopy3(inputs)
	if (locale === "es-MX") return es_mx2_notifications_apikey_nonetocopy3(inputs)
	if (locale === "fil") return fil_notifications_apikey_nonetocopy3(inputs)
	if (locale === "fr") return fr_notifications_apikey_nonetocopy3(inputs)
	if (locale === "it") return it_notifications_apikey_nonetocopy3(inputs)
	if (locale === "hu") return hu_notifications_apikey_nonetocopy3(inputs)
	if (locale === "nl") return nl_notifications_apikey_nonetocopy3(inputs)
	if (locale === "no") return no_notifications_apikey_nonetocopy3(inputs)
	if (locale === "pl") return pl_notifications_apikey_nonetocopy3(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_apikey_nonetocopy3(inputs)
	if (locale === "pt") return pt_notifications_apikey_nonetocopy3(inputs)
	if (locale === "ro") return ro_notifications_apikey_nonetocopy3(inputs)
	if (locale === "fi") return fi_notifications_apikey_nonetocopy3(inputs)
	if (locale === "sv") return sv_notifications_apikey_nonetocopy3(inputs)
	if (locale === "vi") return vi_notifications_apikey_nonetocopy3(inputs)
	if (locale === "tr") return tr_notifications_apikey_nonetocopy3(inputs)
	if (locale === "cs") return cs_notifications_apikey_nonetocopy3(inputs)
	if (locale === "bg") return bg_notifications_apikey_nonetocopy3(inputs)
	if (locale === "ru") return ru_notifications_apikey_nonetocopy3(inputs)
	if (locale === "uk") return uk_notifications_apikey_nonetocopy3(inputs)
	if (locale === "ar") return ar_notifications_apikey_nonetocopy3(inputs)
	if (locale === "hi") return hi_notifications_apikey_nonetocopy3(inputs)
	if (locale === "th") return th_notifications_apikey_nonetocopy3(inputs)
	if (locale === "ja") return ja_notifications_apikey_nonetocopy3(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_apikey_nonetocopy3(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_apikey_nonetocopy3(inputs)
	return ko_notifications_apikey_nonetocopy3(inputs)
});
export { notifications_apikey_nonetocopy3 as "notifications.apiKey.noneToCopy" }